
$w.onReady(function () {
	//TODO: write your page related code here...

});

